import { useContext, useMemo } from "react";
import AuthContext from "../../context/authProvider";
import { deleteHoliday } from "./functions";
import { formatarData } from "../utils/functions";
import SimpleTable from "../table/SimpleTable";

const HolidaysList = ({ holidays, refresh }) => {
    const { user } = useContext(AuthContext);

    const columns = useMemo(() => {
        const handleDelete = async (holiday) => {
            const data = await deleteHoliday(user.token, holiday._id);
            if (data.type === "success") refresh();
        };
        return [
            { key: "name", header: "Nome", width: 200 },
            // Data do feriado é gravada em UTC 00:00: formatarData evita cair no dia anterior.
            { key: "date", header: "Data", width: 110, format: (value) => formatarData(value) },
            {
                key: "excluir", header: "", width: 90, sortable: false, hideable: false, exportable: false,
                cell: ({ row }) => <button type="button" onClick={() => handleDelete(row)} className="bg-blue-500 px-2 text-black hover:bg-blue-800">Excluir</button>,
            },
        ];
    }, [user.token, refresh]);

    return <SimpleTable tableKey="admin-holidays" columns={columns} data={holidays} />;
};

export default HolidaysList;
